import moment from 'moment';

/* eslint-disable quote-props */
const ProcessesReportColumnsExcel = {
  'Ref': 'identification',
  'Etapa': 'step.description',
  'Empresa': 'customer.name',
  'Exportador': 'exporter.name',
  'Ref Pedido': 'customerRef',
  'Outras Referencias': 'anotherRef',
  'Status': 'status',
  'Invoice': 'invoice',
  'Incoterm': 'incoterm',
  'CNTR': 'typeOfBoarding',
  'Prodidão Prevista': {
    field: 'datesEstimatedGoodsReadinesDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'ETD': {
    field: 'datesETD',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'ETA': {
    field: 'datesETA',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Embarque': {
    field: 'datesDepartureDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Chegada': {
    field: 'datesArrivalDate',
    callback: (value) => `${value ? moment(value).format('DD/MM/YYYY') : 'N/I'}`,
  },
  'Nº DI / DUIMP': {
    callback: (value) => {
      if (!value.duimp) {
        return value.diNumber || 'N/I';
      }
      return value.duimpIdentification || 'N/I';
    },
  },
  'Chave DUIMP': 'duimpAccessKey',
  'Registro DI / DUIMP': {
    callback: (value) => {
      if (!value.duimp) {
        return `${value.diRegistryDate ? moment(value.diRegistryDate).format('DD/MM/YYYY') : 'N/I'}`;
      }
      return `${value.duimpRegistryDate ? moment(value.duimpRegistryDate).format('DD/MM/YYYY') : 'N/I'}`;
    },
  },
  'Destinação mercadorias': {
    field: 'processUseOfGoods',
    callback: (value) => {
      if (value && value.length > 0) {
        return value.map((item) => item.description).join(', ');
      }
      return 'N/I';
    },
  },
  'Time Aduaneiro Prime': {
    field: 'customsTeamName',
    callback: (value) => {
      if (value) {
        if (value?.customsTeamEmail) {
          return `${value?.customsTeamName} - ${value?.customsTeamEmail}`;
        }
        return value?.customsTeamName;
      }
      return 'N/I';
    },
  },
  'Time Operacional Prime': {
    field: 'teamName',
    callback: (value) => {
      if (value) {
        if (value?.teamEmail) {
          return `${value?.teamName} - ${value?.teamEmail}`;
        }
        return value?.teamName;
      }
      return 'N/I';
    },
  },
};

export default ProcessesReportColumnsExcel;
